import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    Card,
    CardBody,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CustomInput,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    CardFooter,
} from 'reactstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { NotificationManager } from "../../../../../../components/common/react-notifications";
import { postAPI_User_Website_Images } from "../../../../../../constants/APIs";
import Pagination from '../../../../../../containers/pages/Pagination';
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import classnames from "classnames";
const apiImport_Website = process.env.REACT_APP_MYMA_GPT_API + "/scrap-website";
const defaultImage = 'https://via.placeholder.com/300/';
export function ImagesImport({ propertyId, textUrl, setUrlsText }) {
    const [isAgree, setAgree] = useState(false);
    const [errorModal, showErrorModal] = useState(false);
    const [ApiState, setApiState] = useState('default');
    const [ApiStateImport, setApiStateImport] = useState('default');
    const [websiteLink, setWebsiteLink] = useState({
        url1: '',
        url2: '',
        url3: ''
    });
    const [error, setError] = useState(false);
    const [isImport, setIsImport] = useState(false);
    const [imageDataList, setImageDataList] = useState([]);
    const [imageData, setImageData] = useState([]);
    const [checkedAll, setCheckedAll] = useState(false);
    const [pageSizes, setpageSizes] = useState([10, 15, 20, 25, 30, 45, 50, 100]);
    const [currentPage, setcurrentPage] = useState(1);
    const [selectedPageSize, setSelectedPageSize] = useState(100);
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    useEffect(() => {
        if (textUrl !== undefined) {
            setWebsiteLink({
                url1: textUrl.url1,
                url2: textUrl.url2,
                url3: textUrl.url3
            });
        }
    }, [textUrl]);

    const handleNext = () => {
        if (isAgree) {
            if (websiteLink !== null) {
                setApiState("processing");
                AxiosAPI({
                    method: 'POST',
                    url: `${apiImport_Website}`,
                    data: [websiteLink.url1, websiteLink.url2, websiteLink.url3],
                }).then(res => {
                    var list = [];
                    console.log(res.data);
                    res.data.map(img => (
                        list.push({ imageLink: img, caption: "", tags: [], checked: true })
                    ));
                    //let pp = list.filter((ele, ind) => ind === list.findIndex(elem => elem.imageLink === ele.imageLink));
                    setImageDataList(list);
                    const listLength = list.length;
                    const pages = Math.ceil((listLength / selectedPageSize));
                    setTotalItems(listLength);
                    setTotalPages(pages);
                    setImageData(paginate(list, selectedPageSize, currentPage));
                    setCheckedAll(true);
                    setApiState('success');
                    setIsImport(true);
                },
                    error => {
                        setApiState('fail')
                        console.log('eee.data', error.data);
                    })
            }
            else {
                setError(true);
            }
        }
        else {
            showErrorModal(true);
        }
    }

    function paginate(array, page_size, page_number) {
        return array.slice((page_number - 1) * page_size, page_number * page_size);
    }
    const handleTagChange = (event, i) => {
        var values = [...imageData];
        values[i].tags = event;
        setImageData(values);
    };
    const handleChange = (event, i) => {
        var values = [...imageData];
        values[i].caption = event.target.value;
        setImageData(values);
    };

    const handleChecked = (e) => {
        const list = imageData.map((elem) => {
            if (elem.imageLink === e.target.value) {
                elem.checked = e.target.checked;
            }
            return elem;
        });
        setImageData(list);
        if (imageData.filter((i) => i.checked === true).length === imageData.length) {
            setCheckedAll(true);
        } else {
            setCheckedAll(false);
        }
    }
    const handleAllChecked = (e) => {
        const list = imageData.map((elem) => {
            if (e.target.checked) { elem.checked = true; }
            else { elem.checked = false; }
            return elem;
        });
        setImageData(list);
        setCheckedAll(e.target.checked);
    };
    const handleSubmit = () => {
        setApiStateImport("processing")
        var image = [];
        imageData.filter(i => i.checked === true).map(elem => {
            var img = new Image();
            img.onerror = function () {
                setApiStateImport('default');
                NotificationManager.error(
                    "",
                    "Invalid Image Link",
                    3000,
                    null,
                    null,
                    "error"
                );
            }
            img.src = elem.imageLink;
            var height = 0;
            var width = 0;
            if (img.width) {
                height = img.height;
                width = img.width;
                image.push({
                    caption: elem.caption,
                    tags: elem.tags,
                    imageLink: elem.imageLink,
                    height: height,
                    width: width
                });
            }
        });
        if (image.length > 0) {
            var body = {
                groupId: getGroupID(),
                propertyId: propertyId,
                creator: 'dashboard',
                imageData: image,
                galleryType: "Gallery"
            }
            console.log(body);
            AxiosAPI({
                method: 'post',
                url: `${postAPI_User_Website_Images}`,
                data: body
            }).then(
                res => {
                    setApiStateImport('success');
                    setIsImport(false);
                    setWebsiteLink('');
                    setCheckedAll(false);
                    setAgree(false);
                    setImageDataList([]);
                    setImageData([]);
                    setApiState('default');
                    setApiStateImport('default');
                },
                error => {
                    setApiStateImport('fail')
                    console.log('eee.data', error.data);
                }
            );
        }
    }
    const changeBmbPageSize = (size) => {
        setSelectedPageSize(size);
        setcurrentPage(1);
        const pages = Math.ceil((totalItems / size));
        setTotalPages(pages);
        setImageData(paginate(imageDataList, size, 1));
    };

    const onChangeBmbPage = (page) => {
        setcurrentPage(page);
        setImageData(paginate(imageDataList, selectedPageSize, page));
    };

    const startBmbIndex = (currentPage - 1) * selectedPageSize;
    const endBmbIndex = currentPage * selectedPageSize;

    return (<Fragment>
        <Row className="mt-3 mb-2">
            <Card style={{ width: '100%', borderRadius: '1.25rem' }}>
                <CardBody>
                    <Colxx md="12" className="mt-2 mb-3">
                        <p className='mb-2'>You can give it links to your website(s), and it will bring images from the web pages into the Gallery, saving you enormous time manually importing the images.</p>
                        <p className='mb-2'>You can then use the images to showcase your property features to the guests.</p>
                    </Colxx>
                    <Colxx md={5} className="mb-3 ml-1">
                        <Input
                            type="text"
                            value={websiteLink.url1}
                            onChange={(e) => {
                                setWebsiteLink({ ...websiteLink, url1: e.target.value });
                                setUrlsText({ ...textUrl, url1: e.target.value });
                            }}
                            name="url1"
                            placeholder="https://www.yourwebpage1.com"
                        />
                    </Colxx>
                    <Colxx md={5} className="mb-3 ml-1">
                        <Input
                            type="text"
                            value={websiteLink.url2}
                            onChange={(e) => {
                                setWebsiteLink({ ...websiteLink, url2: e.target.value });
                                setUrlsText({ ...textUrl, url2: e.target.value });
                            }}
                            name="url2"
                            placeholder="https://www.yourwebpage1.com"
                        />
                    </Colxx>
                    <Colxx md={5} className="mb-3 ml-1">
                        <Input
                            type="text"
                            value={websiteLink.url3}
                            onChange={(e) => {
                                setWebsiteLink({ ...websiteLink, url3: e.target.value });
                                setUrlsText({ ...textUrl, url3: e.target.value });
                            }}
                            name="url3"
                            placeholder="https://www.yourwebpage1.com"
                        />
                    </Colxx>
                    <Colxx md={12} className="mb-6">
                        {error &&
                            <div className="invalid-feedback d-block">
                                * please enter website link
                            </div>}
                        <p>All images from the website and subpages will be displayed, you can choose which ones to import</p>
                        <div className='row my-1 ml-0 font-weight-bold mt-4'>
                            <CustomInput
                                type="checkbox"
                                id="agree"
                                value={isAgree}
                                checked={isAgree}
                                onChange={(e) => {
                                    setAgree(!isAgree);
                                }}
                            >
                                <span className='mt-1' style={{ verticalAlign: 'middle' }}>I have copyright or permissions to all images on this website</span>
                            </CustomInput>
                        </div>
                    </Colxx>
                    <Colxx md={12} className="mb-2 mt-4">
                        <Button color="primary" onClick={handleNext}
                            className={`btn-multiple-state ${classnames(
                                {
                                    "show-spinner": ApiState === "processing",
                                    "show-success": ApiState === "success",
                                    "show-fail": ApiState === "fail"
                                }
                            )}`}
                        >
                            <span className="spinner d-inline-block">
                                <span className="bounce1" />
                                <span className="bounce2" />
                                <span className="bounce3" />
                            </span>
                            <span className="icon success">
                                <i className="simple-icon-check" />
                            </span>
                            <span className="icon fail">
                                <i className="simple-icon-exclamation" />
                            </span>
                            <span className="label">Fetch Images</span>
                        </Button>
                    </Colxx>
                </CardBody>
            </Card>
        </Row>
        {isImport && (
            <Row className="mt-3 mb-2">
                <Card style={{ width: '100%', borderRadius: '1.25rem' }}>
                    <CardBody>
                        <Colxx md="12" style={{ maxHeight: "590px", height: "100%", overflowY: "scroll" }}>
                            <Row className="mb-4">
                                <Colxx xxs={6}>
                                    <CustomInput
                                        type="checkbox"
                                        id={"checkall"}
                                        label="Select All"
                                        checked={checkedAll}
                                        onChange={(e) => handleAllChecked(e)}
                                    />
                                </Colxx>
                                <Colxx xxs="6">
                                    <div className="float-md-right">
                                        <span className="text-muted text-small mr-1">{`${startBmbIndex}-${endBmbIndex} of ${totalItems} `}</span>
                                        {/* <UncontrolledDropdown className="d-inline-block">
                                            <DropdownToggle caret color="outline-dark" size="xs">
                                                {selectedPageSize}
                                            </DropdownToggle>
                                            <DropdownMenu right>
                                                {pageSizes.map((size, index) => {
                                                    return (
                                                        <DropdownItem
                                                            key={index}
                                                            onClick={() => changeBmbPageSize(size)}
                                                        >
                                                            {size}
                                                        </DropdownItem>
                                                    );
                                                })}
                                            </DropdownMenu>
                                        </UncontrolledDropdown> */}
                                    </div>
                                </Colxx>
                            </Row>
                            <Row className="mb-4">
                                {imageData.map((img, index) => (
                                    <Colxx sm={2} key={index} className="mb-4">
                                        <div className='d-flex' style={{ flexDirection: "column" }}>
                                            <CustomInput
                                                type="checkbox"
                                                id={"property_" + index}
                                                value={img.imageLink}
                                                checked={img.checked}
                                                onChange={(e) => handleChecked(e)}
                                            />
                                            <div style={{ height: "100px" }}>
                                                <img src={img.imageLink} style={{ width: "100%", height: "100%" }}></img>
                                            </div>
                                            <div>
                                                <TagsInput
                                                    value={img.tags}
                                                    onChange={event => handleTagChange(event, index)}
                                                />
                                                <Input
                                                    type="text"
                                                    name="caption"
                                                    placeHolder="Caption"
                                                    value={img.caption}
                                                    onChange={event => handleChange(event, index)}
                                                />
                                            </div>
                                        </div>
                                    </Colxx>
                                ))}
                            </Row>
                            <Row>
                                <Pagination
                                    currentPage={currentPage}
                                    totalPage={totalPages}
                                    onChangePage={(i) => onChangeBmbPage(i)}
                                />
                            </Row>
                        </Colxx>
                    </CardBody>
                    <CardFooter style={{
                        backgroundColor: "#fff",
                        borderBottomLeftRadius: "1.25rem",
                        borderBottomRightRadius: "1.25rem"
                    }}>
                        <Colxx md={12}>
                            <Button color="primary" onClick={handleSubmit}
                                className={`btn-multiple-state ${classnames(
                                    {
                                        "show-spinner": ApiStateImport === "processing",
                                        "show-success": ApiStateImport === "success",
                                        "show-fail": ApiStateImport === "fail"
                                    }
                                )}`}
                            >
                                <span className="spinner d-inline-block">
                                    <span className="bounce1" />
                                    <span className="bounce2" />
                                    <span className="bounce3" />
                                </span>
                                <span className="icon success">
                                    <i className="simple-icon-check" />
                                </span>
                                <span className="icon fail">
                                    <i className="simple-icon-exclamation" />
                                </span>
                                <span className="label">Import</span>
                            </Button>
                        </Colxx>
                    </CardFooter>
                </Card>
            </Row>
        )}
        <Modal isOpen={errorModal} toggle={() => showErrorModal(!errorModal)}>
            <ModalHeader toggle={() => showErrorModal(!errorModal)}></ModalHeader>
            <ModalBody>
                <div className='m-2'>
                    <h5>Please check the copyright or permissions check box</h5>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={() => showErrorModal(!errorModal)}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    </Fragment>)
}